<template>
  <div
    class="layout__component-container-wrap layout__component-container-wrap--dark layout--padding-bottom-xl"
  >
    <div class="layout__component-container layout__component-container--dark">
      <h2 class="text-size-xl weight--bold layout--margin-bottom-xs">
        Change Your Plan
      </h2>
      <router-link
        :to="{ name: getBackInfo.routeName }"
        class="link account__back-link"
        ><IconArrowBack class="icon layout--margin-right-xs" />{{
          getBackInfo.text
        }}</router-link
      >
      <div class="account__main-content">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import ChevronIcon from "../../assets/icons/icon-chevron.svg";
import IconArrowBack from "../../assets/icons/iconArrowBack.svg";

import { mapGetters, mapActions } from "vuex";

export default {
  name: "ChangePlan",
  components: {
    ChevronIcon,
    IconArrowBack,
  },
  computed: {
    ...mapGetters("account", ["data"]),
    getBackInfo() {
      const { name } = this.$route;

      switch (name) {
        case "choose billing period":
          return {
            text: "Back to Plans",
            routeName: "change plan",
          };
        case "summary":
          return {
            text: "Back to Choose Billing Period",
            routeName: "choose billing period",
          };
        case "change plan":
        default:
          return {
            text: "Back to My Account",
            routeName: "account",
          };
      }
    },
  },
};
</script>

<style lang="scss">
@import "../../styles/pages/_changeAccount.scss";
</style>
